import { connect } from "react-redux";

import { getHealthStatus } from "redux/Datasets/selectors";
import { State } from "redux/store";

import VLTooltip from "views/uikit/VLTooltip";
import { Badge } from "antd";
import styles from "./style.module.scss";

const HealthStatus = ({ healthStatus }: any) => {
  return (
    healthStatus &&
    healthStatus.status !== "Green" && (
      <VLTooltip
        title={healthStatus["service-health-message"]}
        placement="bottomRight"
      >
        <Badge status="error" className={styles.badge} />
      </VLTooltip>
    )
  );
};

const mapStateToProps = (state: State) => {
  return {
    healthStatus: getHealthStatus(state),
  };
};

export default connect(mapStateToProps)(HealthStatus);
